export default __webpack_public_path__ + "static/media/background4.8b11a6fc.png";